import { Component, OnInit } from '@angular/core';
import { AppComponentClass } from '../../shared/service/AppComponent.class';
import { Smtp, SmtpForm } from '../../setting/model/model.class';
import { FormGroup, FormBuilder } from '@angular/forms';
import { SPSmtpService } from '../profile.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar, MatDialog } from '@angular/material';
import { TestemailComponent } from '../../shared/testemail/testemail.component';
import { InheritSMTPComponent } from '../../shared/inherit-smtp/inherit-smtp.component';

@Component({
  selector: 'app-spsmtp',
  templateUrl: './spsmtp.component.html',
  styleUrls: ['./spsmtp.component.css']
})
export class SpsmtpComponent extends AppComponentClass<Smtp, SmtpForm> {

  key: number;
  form: FormGroup;
  submitted: boolean = false;
  updateTest = [];
  name: any = "Gmail"
  activeclass: any = "active";
  domain_name: any = "smtp.gmail.com"
  emailtype: any = 0;
  smtp_port: any = 465;
  setemailtype: number = 0;
  other: boolean = false;
  type: number = parseInt(sessionStorage.getItem('type'))

  domainType = [
    { emailtype: "0", key: "Gmail", value: "smtp.gmail.com", smtp_port: '465', },
    { emailtype: "1", key: "Outlook", value: "smtp-mail.outlook.com", smtp_port: '587' },
    { emailtype: "2", key: "Yahoo", value: "smtp.mail.yahoo.com", smtp_port: '587' },
    { emailtype: "3", key: "Hotmail", value: "smtp.office365.com", smtp_port: '587' },
    { emailtype: "4", key: "Other" }
  ];
  keyfields: any;
  permissionData: any = "";
  permissionSMTP: any;

  constructor(protected data: SPSmtpService, protected router: Router, protected fb: FormBuilder, protected msg: MatSnackBar, public dialog: MatDialog,private activatedroute: ActivatedRoute) {
    super(data, router, fb, msg);
    this.key = parseInt(sessionStorage.getItem('iduser'));
    this.cdata = new SmtpForm(null);
    this.form = this.cdata.makeform(this.fb);
  }

  ngOnInit(): void {

    console.log(this.type);

    //indexing dor field TAB.
    document.getElementsByTagName('div')[0].focus();

    this.data.getService().subscribe(res => {
      this.updateTest = res;
      console.log("ngOnit data", this.updateTest);

      if (res != null && res.length > 0) {
        for (let i of res) {
          if (i.default == 1) {
            this.cdata = new SmtpForm(i);
            this.form = this.cdata.makeform(this.fb);
            this.keyfields = i.id;
            console.log(i.emailtype);
            this.TabActivate(i.emailtype);
          } else {
            this.cdata = new SmtpForm(res[0]);
            this.form = this.cdata.makeform(this.fb);
            this.keyfields = res[0].id;
            this.TabActivate(res[0].emailtype);
          }
        }
      }
      else {
        this.keyfields = -1;
        this.cdata = new SmtpForm(null);
        this.form = this.cdata.makeform(this.fb);
        this.TabActivate(0);
      }
    },
      err => {
        this.keyfields = -1;
        this.cdata = new SmtpForm(null);
        this.form = this.cdata.makeform(this.fb);
        this.TabActivate(0);
      });
    console.log(this.cdata, "cdata");
    console.log(this.name, "name value")

    this.smtpStatus_Request();

    if(parseInt(this.activatedroute.snapshot.queryParamMap.get('sp'))){
        this.requestSMTP(0)
    }
  }

  // convenience getter for easy access to form fields
  get f() { return this.form.controls; }

  onReset() {
    this.data.ResetSMTP(JSON.stringify({ id: this.keyfields, emailtype: this.cdata.emailtype })).subscribe(res => {
      this.keyfields = -1;
      this.cdata = new SmtpForm(null);
      this.form = this.cdata.makeform(this.fb);
      this.openSnackBar(res.message, "Clear");
      this.ngOnInit();
    });
  }

  activeTab(smtptype: any, clr: any) {
    console.log(smtptype)

    if (smtptype.key == 'Gmail') {
      $('#Gmail').addClass('classOne');
      $('#Outlook').removeClass('classOne');
      $('#Yahoo').removeClass('classOne');
      $('#Hotmail').removeClass('classOne');
      $('#Other').removeClass('classOne');
    }

    if (smtptype.key == 'Outlook') {
      $('#Outlook').addClass('classOne');
      $('#Gmail').removeClass('classOne');
      $('#Yahoo').removeClass('classOne');
      $('#Hotmail').removeClass('classOne');
      $('#Other').removeClass('classOne');
    }

    if (smtptype.key == 'Yahoo') {
      $('#Yahoo').addClass('classOne');
      $('#Gmail').removeClass('classOne');
      $('#Outlook').removeClass('classOne');
      $('#Hotmail').removeClass('classOne');
      $('#Other').removeClass('classOne');
    }

    if (smtptype.key == 'Hotmail') {
      $('#Hotmail').addClass('classOne');
      $('#Gmail').removeClass('classOne');
      $('#Outlook').removeClass('classOne');
      $('#Yahoo').removeClass('classOne');
      $('#Other').removeClass('classOne');
    }

    if (smtptype.key == 'Other') {
      $('#Other').addClass('classOne');
      $('#Gmail').removeClass('classOne');
      $('#Outlook').removeClass('classOne');
      $('#Yahoo').removeClass('classOne');
      $('#Hotmail').removeClass('classOne');
    }

    if (smtptype.emailtype == "4") {
      this.other = true
    }
    else {
      this.other = false
    }

    this.setemailtype = smtptype.emailtype;
    this.domain_name = smtptype.value;
    this.smtp_port = smtptype.smtp_port;
    this.name = smtptype.key;
    this.form.patchValue({
      smtp_port: smtptype.port,
      emailtype: smtptype.emailtype
    })
    if (this.updateTest.length > 0) {
      for (let i of this.updateTest) {
        if (smtptype.emailtype == i.emailtype) {
          this.cdata = new SmtpForm(i);
          this.form = this.cdata.makeform(this.fb)
          this.keyfields = i.id;
          break
        } else {
          this.cdata = new SmtpForm(null);
          this.form = this.cdata.makeform(this.fb);
          this.keyfields = -1;
        }
      }
    } else {
      this.cdata = new SmtpForm(null);
      this.form = this.cdata.makeform(this.fb);
      this.keyfields = -1;
      this.TabActivate(smtptype.emailtype);
    }

  }

  TabActivate(emailtype: number) {
    console.log(emailtype);

    switch (emailtype) {
      case 0: {
        this.name = "Gmail";
        this.setemailtype = 0;
        this.other = false;
        console.log("this.setemailtype",this.setemailtype);
        
        //this.activeTab("Gmail");
        break
      }
      case 1: {
        this.name = "Outllook";
        this.setemailtype = 1;
        this.other = false;
        //this.activeTab("Outllook");
        break
      }
      case 2: {
        this.name = "Yahoo";
        this.setemailtype = 2;
        this.other = false;
        //this.activeTab("Yahoo");
        break
      }
      case 3: {
        this.name = "Hotmail";
        this.setemailtype = 3;
        this.other = false;
        //this.activeTab("Hotmail");

        break
      }
      case 4: {
        this.name = "Other";
        this.setemailtype = 4;
        this.other = true;
        //this.activeTab("Other");
        break
      }
    }
  }

  TestEmail() {
    let formData = this.form.value;
    if (this.domain_name) { formData.domain = this.domain_name }
    if (this.smtp_port) { formData.smtp_port = this.smtp_port }
    console.log("formData", formData);
    const dialogRef = this.dialog.open(TestemailComponent, {
      width: '700px',
      data: ''
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res != null && res != undefined) {
        console.log(this.keyfields);
        console.log(res);
        console.log(this.setemailtype);
        console.log(this.setemailtype);
        
        this.data.SendTestEmail(JSON.stringify({ keyfield: this.keyfields, mail: res, formdata: formData, emailtype: this.setemailtype })).subscribe(rss => {
          this.openSnackBar(rss.message, "Clear");
          this.ngOnInit();
        },
          err => {
            this.openSnackBar("Email sending failed.", "Clear");
          });
      }
    });
  }

  MakeDefault() {
    this.data.MakeDefaultSMTP(null, this.keyfields).subscribe((res) => {
      this.openSnackBar(res.message, "Clear");
      this.ngOnInit();
    },
      err => { });
  }
  smtpStatus_Request() {
    this.data.get_Permission("permissionSMTP").subscribe((res: any) => {
      console.log("res::::::::::", res)
      this.permissionSMTP = res
      this.permissionData = res[0].status

    }, err=>{
      console.log("err::::::::::", err)
      this.permissionSMTP = []
      this.permissionData = ''
    })
  }

  requestSMTP(typeReq?: any) {
    if (this.type == 5) {
      if (typeReq == 1) {
        const dialogRef = this.dialog.open(InheritSMTPComponent, {
          width: '700px',
          data: { res: this.permissionSMTP, agtype: typeReq }
        });
      } else {
        this.data.getService("getSuper").subscribe((res: any) => {
          console.log(res);
          const dialogRef = this.dialog.open(InheritSMTPComponent, {
            width: '700px',
            data: { res: res, agtype: typeReq }
          });
          dialogRef.afterClosed().subscribe(res => {
            if (res != null && res != undefined) {
              this.data.request_SMTP(res).subscribe((resdara: any) => {
                console.log(resdara);

              })
            }
          })
        })
      }
    } else {
      console.log(this.permissionSMTP);

      const dialogRef = this.dialog.open(InheritSMTPComponent, {
        width: '700px',
        data: this.permissionSMTP
      });
      dialogRef.afterClosed().subscribe(res => {
        if (res != null && res != undefined) {
          console.log(res);
          this.data.updateService({ status: res.status }, res.id, 'permissionSMTP').subscribe(res => {
            this.smtpStatus_Request();
          })
        }
      })
    }


  }

}
